import { useMutation } from '@tanstack/react-query';

import { clientAxios } from '@/shared/api';

export const useRequestFortuneMutation = () => {
  return useMutation({
    mutationFn: ({ userRole }: { userRole: string }) =>
      clientAxios.post<{ fortuneText: string }>('/fortune/', {
        userRole,
      }),
  });
};
